<script setup lang="ts">
  import NotifyMe from '@/components/notify.vue'
  import { onMounted as mounted } from 'vue'
  import { use_notify } from '@/stores/notify'
  import '@/utils/bilin-pixel-snippet'
  const { log } = use_notify()
  mounted(() => log('app-guest', navigator.userAgent, document.referrer))
</script>

<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <aside>
      <notify-me />
    </aside>
  </v-app>
</template>
